export default () => {
  const dataLayer = getShoptetDataLayer()
  const isCategoryPage = dataLayer.pageType === 'category';

  if (isCategoryPage) {
    console.log('category page')

    /* FUNKCE */
    const makeAllElementSubcategories = (elementClass) => {
      const anchor = $('.menu-level-1 li').find('a.active').attr('href')
      const elAll = $('<li class="' + elementClass + '"><a href="'+ anchor +'"></span><span class="text">All</span></a></li>')
      elAll.prependTo('.subcategories')
    }

    // odebere classu pro zrušení default stylů
    $('.subcategories li').each(function () {
      $(this).removeAttr('class');
    })

    // dává parent class pokud jsem na nějaké subkategorii
    $('.menu-level-2').each(function () {
      const activeItem = $(this).find('li.active')

      if (activeItem.length > 0) {
        activeItem.closest('ul').closest('li').children('a').addClass('active')
      }
    })

    const subcategories = document.querySelector('.subcategories')

    if (subcategories) {
      makeAllElementSubcategories('active')
    } else {
      // připne menu level 2 nad výpis produktů
      const menu = $('.navigation-in .menu-level-1').find('a.active').closest('li').find('.menu-level-2')
      menu.appendTo('.category-top')

      // odebere a přiřadí classu pro stylování
      $('.menu-level-2 li').removeClass('col-xs-6 col-sm-6 col-lg-3 col-xl-3')
      menu.removeClass('menu-level-2').addClass('subcategories with-image')

      makeAllElementSubcategories('no-active')

    }

  }
};
